import React from "react"
import * as Toast from "@radix-ui/react-toast"
import {
  toastContainer,
  toastRoot,
  toastText,
  toastIcon,
  toastViewport,
} from "./NotificationComponent.css"
import { TickIcon } from "components/SvgIcons"

export type Props = {
  title: string
  visible: boolean
  setIsVisible: (open: boolean) => void
  duration?: number
}

export const NotificationComponent: React.FC<Props> = ({
  title,
  visible,
  setIsVisible,
  duration,
}) => {
  return (
    <Toast.Provider swipeDirection="right" duration={duration ?? 2000}>
      <Toast.Root
        className={toastRoot}
        open={visible}
        onOpenChange={(open) => {
          if (!open) {
            setIsVisible(false)
          }
        }}
      >
        <Toast.Title>
          <div className={toastContainer}>
            <div className={toastIcon}>
              <TickIcon />
            </div>
            <div className={toastText}>{title}</div>
          </div>
        </Toast.Title>
      </Toast.Root>
      <Toast.Viewport className={toastViewport} />
    </Toast.Provider>
  )
}
